import { createBrowserRouter } from 'react-router-dom';
import App from './App';
import Home from './pages/Home';
import CustomerDetail from './pages/CustomerDetail';
import Register from './pages/Register';
import Setup from './pages/Setup';
import Earn from './pages/Earn';
import Redeem from './pages/Redeem';
import Admin from './pages/Admin';

export const router = createBrowserRouter([
    {
        path: "/",
        element: <App />,
        children: [
            {
                index: true,
                element: <Home />,
            },
            {
                path: "customer/:id",
                element: <CustomerDetail />,
            },
            {
                path: "customer/:id/earn",
                element: <Earn />,
            },
            {
                path: "customer/:id/redeem",
                element: <Redeem />,
            },
            {
                path: "register",
                element: <Register />,
            },
            {
                path: "setup",
                element: <Setup />,
            },
            {
                path: "admin",
                element: <Admin />,
            },
        ],
    },
]);
